import { render, staticRenderFns } from "./AdditionalServices.vue?vue&type=template&id=446e5cd2&scoped=true&"
import script from "./AdditionalServices.vue?vue&type=script&lang=js&"
export * from "./AdditionalServices.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalServices.vue?vue&type=style&index=0&id=446e5cd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446e5cd2",
  null
  
)

export default component.exports